<template>
  <span v-safe-html="textWithEmoji" />
</template>

<script lang="ts" setup>
import { useWidgetTextWithEmoji } from '@widgets/messenger/compositions/useWidgetTextWithEmoji'

const props = defineProps<{
  text?: string
  emojiSize?: string // example: 22px
}>()

const { textWithEmoji } = useWidgetTextWithEmoji(
  () => props.text,
  () => props.emojiSize,
)
</script>
